import { error } from "console";
import { useEffect, useState }    from "react";
import Feature         from "../models/GISCO/Feature";
import { Institution } from "../models/Institution";

/** Custom properties for GiscoFeatureDialog component 
  * can be consumed by the parent element */
type FeatureDialogProps = {

    show:    boolean,
    feature: Feature | null,

    /**
     * Callback method that gets executed when dialog closes successful.
     * @param institution
     * @returns
     */
    onConfirm: (institution: Institution, feature: Feature | null) => void,

    /**
     * Callback method that gets executed when dialog closes unsuccessful.
     * @returns
     */
    onAbort: () => void,
}

const GiscoFeatureDialog = ({ show, feature, onConfirm, onAbort }: FeatureDialogProps) => {

    /* Using "Spread" operator [...] to copy init feature object */
    const [instituion, setInstitution] = useState<Institution>({
        name: "",
        address: {
            street: "",
            postalCode: feature?.properties.postcode ?? "",
            city:       "",
            country:    ""
        }
    });

    useEffect(() => {

        setInstitution({ /* Spread feature data to response object */

            name: feature?.properties.type === "house" && feature.properties.name !== undefined ? feature.properties.name : "",
            address: {

                street     : feature?.properties.type === "street" && feature.properties.name !== undefined ? feature.properties.name : feature?.properties.street !== undefined ? feature.properties.street : "",
                city       : feature?.properties.type === "city" && feature.properties.name   !== undefined ? feature.properties.name : feature?.properties.city   !== undefined ? feature.properties.city : "",

                postalCode : feature?.properties.postcode    !== undefined ? feature.properties.postcode : "",
                country    : feature?.properties.countrycode !== undefined ? feature.properties.countrycode : ""
            }
        })

    }, [show, feature])

    function handleOKButton(): void {

        let errors: string[] = []; 

        if (instituion.name === "")               errors.push("Field Instituion is mandatory.")
        if (instituion.address.street === "")     errors.push("Field Street is mandatory.")
        if (instituion.address.city === "")       errors.push("Field City is mandatory.")
        if (instituion.address.postalCode === "") errors.push("Field PostalCode is mandatory.")

        if (errors.length === 0) {

            /* Invoke callback method an pass on Instituion object */
            onConfirm(instituion, feature);
        }
    }

    return (
        <div className={"modal fade" + (show ? " show" : "")} role="dialog" tabIndex={-1}>
            <div className="modal-dialog">

                <div className="modal-content">
                    <div className="modal-header bg-light text-center">
                        <p className="mb-0 fw-bold w-100"><i className="bi bi-exclamation-circle me-1"></i>Missing required address data</p>
                    </div>
                    <div className="modal-body">

                        <div className="row">
                            <div className="col-12">
                                <div className="alert alert-warning">
                                    The suggestion you have selected does not include all <strong>mandatory</strong> fields. Please complete the marked fields.
                                </div>
                            </div>
                        </div>

                        <div className="row">

                            <div className="form-group col-12 text-start">
                                <label htmlFor="FeatureInstitution" className="fw-bold">Institution / Company</label>
                                <input id="FeatureInstitution" name="FeatureInstitution" className={"form-control" + (instituion.name === "" ? " border-warning" : "")} onChange={e => setInstitution(x => ({ ...x, name: e.target.value }))} value={instituion.name} />
                            </div>
                            <div className="form-group col-12 text-start">
                                <label htmlFor="FeatureStreet" className="fw-bold">Street</label>
                                <input id="FeatureStreet" name="FeatureStreet" className={"form-control" + (instituion.address.street === "" ? " border-warning" : "")} onChange={e => setInstitution(x => ({ ...x, address: ({ ...x.address, street: e.target.value }) }))} disabled={(feature?.properties.type === "street" && feature.properties.name !== undefined) || feature?.properties.street !== undefined} value={instituion.address.street} />
                            </div>
                            <div className="form-group col-12 col-md-4 text-start">
                                <label htmlFor="FeaturePostalCode" className="fw-bold">Postal Code</label>
                                <input id="FeaturePostalCode" name="FeaturePostalCode" className={"form-control" + (instituion.address.postalCode === "" ? " border-warning" : "")} onChange={e => setInstitution(x => ({ ...x, address: ({ ...x.address, postalCode: e.target.value }) }))} disabled={feature?.properties.postcode !== undefined} value={instituion.address.postalCode} />
                            </div>
                            <div className="form-group col-12 col-md-4 text-start">
                                <label htmlFor="FeatureCity" className="fw-bold">City</label>
                                <input id="FeatureCity" name="FeatureCity" className={"form-control" + (instituion.address.city === "" ? " border-warning" : "")} onChange={e => setInstitution(x => ({ ...x, address: ({ ...x.address, city: e.target.value }) }))} disabled={(feature?.properties.type === "city" && feature.properties.name !== undefined) || feature?.properties.city !== undefined} value={instituion.address.city} />
                            </div>
                            <div className="form-group col-12 col-md-4 text-start">
                                <label htmlFor="FeatureCountry" className="fw-bold">Country</label>
                                <input id="FeatureCountry" className="form-control" disabled={true} value={feature?.properties.country}></input>
                            </div>

                        </div>

                    </div>

                    <div className="modal-footer bg-light">
                        <button className="btn btn-danger"  type="button" onClick={onAbort}><i className="bi bi-x-circle"></i></button>
                        <button className="btn btn-success" type="button" onClick={handleOKButton}><i className="bi bi-check-lg"></i></button>
                    </div>

                </div>

            </div>
        </div>
    )
}
export default GiscoFeatureDialog;